import styles from 'components/Cart/OrderSummary/HardwarePayment/HardwarePayment.module.scss';
import orderSummaryStyles from 'components/Cart/OrderSummary/OrderSummary.module.scss';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Tooltip from '@material-ui/core/Tooltip';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from 'components/Image/Image';
import { TextV2 } from 'components/TextV2/TextV2';
import infoIcon from 'images/icons/info.svg';
import { SUBTOTAL_TITLE_TEST_ID } from './SubtotalTitle.const';

interface ISubtotalTitleProps {
  isCheckout?: boolean;
  summaryTitle?: string;
}

export const SubtotalTitle: React.FC<ISubtotalTitleProps> = ({ isCheckout, summaryTitle }) => {
  const { t } = useTranslation();
  const [isTotalTooltip, setTotalTooltip] = useState<boolean>(false);

  return (
    <div className={styles.containerHeading}>
      <TextV2 tagName="h4" variant="eyebrow" className={orderSummaryStyles.heading} value={summaryTitle} />
      {isCheckout && (
        <ClickAwayListener onClickAway={() => setTotalTooltip(false)}>
          <Tooltip
            title={`${t('order-summary.you-have-chosen')} ${t('order-summary.one-installment-payment')}`}
            open={isTotalTooltip}
            placement="top"
            arrow
            classes={{ popper: styles.tooltip }}
            data-testid={SUBTOTAL_TITLE_TEST_ID.tooltip}
          >
            <Image
              src={infoIcon}
              className={styles.containerIcon}
              onClick={() => setTotalTooltip(!isTotalTooltip)}
              alt={t('info')}
              data-testid={SUBTOTAL_TITLE_TEST_ID.infoIcon}
            />
          </Tooltip>
        </ClickAwayListener>
      )}
    </div>
  );
};

SubtotalTitle.displayName = 'SubtotalTitle';
